export const CHAIN_ID = 2300;

export const RPC_URL = "https://rpc.bombchain.com";

export const CONTRACT_ADDRESSES = {
  pool: "0x36Ffe18A023e79567122281bDea5E28661bFB4f8",
  sbomb: "0x2a4a10237CBec8ef5FFe4eE4770D467966c4FEc4",
};
